import { useState, useContext, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import css from "../../css/common.module.css";
import "../../css/popup.css";
import Footer from "../Navigation/Footer";
import Header from "../Navigation/Header";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';

function Landing() {
	const userCtx = useContext(UserContext);
	const [appNames, setAppNames] = useState([]);
	const [analytics, setAnalytics] = useState([]);
	const [complete, setComplete] = useState(false);
	const { t } = useTranslation();
	const navigate = useNavigate();
	useEffect(() => {
		checkUserAuthentication();
	}, []);

	function checkUserAuthentication() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ "source": "web" }),
		};
		try {
			FetchUtil.fetchAPI("CheckAuth", "/Service/StaticNav/CheckAuth", requestOptions, checkAuthSuccess, checkAuthFail);
		} catch (error) {
			navigate("/", {
				state: {
					errorMessage: error.message,
				},
			});
		}
	}

	function checkAuthFail(redirect) {
		navigate("/", {
			state: {
				errorMessage: t("error.userAuthFailed"),
			},
		});
	}

	function checkAuthSuccess(responseData) {
		setComplete(true);
		let logonServiceResponse;
		if (responseData) {
			logonServiceResponse = responseData.logonServiceResponse;
			if (!logonServiceResponse) {
				logonServiceResponse = responseData.logonResponse;
			}
			if (logonServiceResponse && logonServiceResponse.errorCode === "0") {
				userCtx.addUserName(logonServiceResponse.userName);
				userCtx.addLoggedInUserId(logonServiceResponse.userId);
				userCtx.addRole(logonServiceResponse.userRole);
				userCtx.addIsAuthenticated(true);
				userCtx.addEnabledMFA(logonServiceResponse.enabledMFA);
				userCtx.addLang(logonServiceResponse.userLanguage);
				setAppNames([...appNames, ...logonServiceResponse.appAccess]);
				setAnalytics([...analytics, ...logonServiceResponse.analytics]);
				userCtx.addAnalyticsAccess(logonServiceResponse.analytics);
				userCtx.addUserCompanyId(logonServiceResponse.companyID);
				userCtx.addUserType(logonServiceResponse.userType);
				userCtx.addCompanyType(logonServiceResponse.companyType);
				userCtx.addHasDeleteAccess(logonServiceResponse.hasDeleteAccess);
			} else if (logonServiceResponse.errorCode === "114") {
				userCtx.addUserName("");
				userCtx.addLoggedInUserId("");
				userCtx.addRole("");
				userCtx.addIsAuthenticated(false);
				userCtx.clearStorage();
				userCtx.addEnabledMFA(0);
				userCtx.addAnalyticsAccess([]);
				userCtx.addUserCompanyId(0);
				userCtx.addUserType("");
				userCtx.addCompanyType("");
				userCtx.addHasDeleteAccess(false);
				let logoutWindow = window.open("https://idecisionsciences.awsapps.com/start#/signout", "AWS Logout", "width=100,height=100");
				if (logoutWindow) {
					let timeoutVar = setTimeout(
						function() {

							logoutWindow.close();
							if (logoutWindow.closed) {
								navigate("/", {
									state: {
										errorMessage: "",
									},
								});
							}
						}
							.bind(this),
						5000
					);
				} else {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				}

			} else {
				deleteAllCookies();
				navigate("/", {
					state: {
						errorMessage: t("error.error") + " " + logonServiceResponse.errorMessage,
					},
				});

			}
		}
	}

	function deleteAllCookies() {
		let cookies = document.cookie.split("; ");
		for (let c = 0; c < cookies.length; c++) {
			let d = window.location.hostname.split(".");
			while (d.length > 0) {
				let cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
				let p = location.pathname.split('/');
				document.cookie = cookieBase + '/';
				while (p.length > 0) {
					document.cookie = cookieBase + p.join('/');
					p.pop();
				};
				d.shift();
			}
		}
	}
	return (
		<div className="container-fluid">
			<Header />
			<div className={"container-fluid viewh-85 " + css.homebg}>
				<div className="row">
					<div id="submit-spinner"
						className={complete ? "spinner-hide" : "spinner-border spinner-border-sm text-dark spinner-size"}
					/>
					{(complete && appNames.length > 0)? (appNames.map((appNameObj) => (
						appNameObj.appName !== "Customer" &&
						<div className="col-6 col-md-3 col-lg-2" style={{ width: "25vw", margin: "16px 0 24px 0" }} >
							<div className="card card-bginfo text-dark">
								<div className="card-body">
									<h5 className="card-title">{appNameObj.appDisplayName}</h5>
									<p className="card-text">{appNameObj.appDescription}</p>
									<a href={appNameObj.appURL} target="_blank" class="btn btn-primary">{t("page.openApp") + " " + appNameObj.appDisplayName}</a>
								</div>
							</div>
						</div>
					))):(<></>)}
					{(complete && analytics.length > 0)? 
						<div className="col-6 col-md-3 col-lg-2" style={{ width: "25vw", margin: "16px 0 24px 0" }} >
							<div className="card card-bginfo text-dark">
								<div className="card-body">
									<h5 className="card-title">{t("header.analytic")}</h5>
									<p className="card-text">{t("header.analytic")}</p>
									<NavLink to="/pages/analyticsLanding" className="btn btn-primary"><span class="fa fa-bar-chart"> </span>
				                		{t("header.analytic")}
				               		</NavLink>
								</div>
							</div>
						</div>
					:(<></>)}
				</div>
			</div>
			<div className="footer_container">
				<Footer />
			</div>
		</div>
	);
}
export default Landing;
